import TollOutlinedIcon from '@mui/icons-material/TollOutlined';
import { Box, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';

import { getCreditsAriaLabel, getFromCreditsAriaLabel } from '../../../constants/marketplace';

interface IProps {
  credits: number;
  // The cheapest variant, when the exact price depends on the option picked.
  isFromPrice?: boolean;
  sx?: SxProps<Theme>;
}

const chipSx: SxProps<Theme> = { display: 'inline-flex', alignItems: 'center', gap: 0.5, color: 'text.primary' };

const iconSx: SxProps<Theme> = { fontSize: 18, color: 'text.primary' };

export const CreditChip: React.FC<IProps> = ({ credits, isFromPrice = false, sx }) => (
  <Box
    aria-label={isFromPrice ? getFromCreditsAriaLabel(credits) : getCreditsAriaLabel(credits)}
    sx={{ ...chipSx, ...sx }}
  >
    {isFromPrice && (
      <Typography component="span" variant="body2" color="text.secondary" sx={{ fontSize: '12px', fontWeight: 400 }}>
        From
      </Typography>
    )}
    <TollOutlinedIcon sx={iconSx} />
    <Typography component="span" variant="body2" fontWeight="medium">
      {credits}
    </Typography>
  </Box>
);
